import React, { useEffect, useState } from "react";
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { supabase } from "../lib/supabaseClient.ts";
import MySlider from "./MySlider.js";

function MainSlider() {
  const CustomPrevArrow = ({ onClick }) => (
    <div
      className="custom-arrow-left"
      onClick={onClick}
      style={{
        position: "absolute",
        left: "15px",
        top: "52%",
        transform: "translateY(-50%)",
        zIndex: 10,
        cursor: "pointer",
        fontSize: "22px",
        color: "#ff41b4",
        background: "transparent", 
        borderRadius: "50%",
        padding: "8px"
      }}
    >
      <FaChevronLeft />
    </div>
  );

  const CustomNextArrow = ({ onClick }) => (
    <div
      className="custom-arrow-right"
      onClick={onClick}
      style={{
        position: "absolute",
        right: "15px",
        top: "52%",
        transform: "translateY(-50%)",
        zIndex: 10,
        cursor: "pointer",
        fontSize: "22px",
        color: "#ff41b4",
        background: "transparent", 
        borderRadius: "50%",
        padding: "8px"
      }}
    >
      <FaChevronRight />
    </div>
  );

  const settings = {
    autoplay: false,
    autoplaySpeed: 10000,
    dots: false,
    fade: true,
    arrows: true,
    swipe: true,
    touchMove: true,
    // nextArrow: <CustomNextArrow />,
    // prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 767, settings: { dots: false, arrows: false } }
    ]
  };
const [slides, setSlides] = useState([]);

useEffect(() => {
  const fetchSlides = async () => {
    const { data, error } = await supabase
      .from('main_slider')
      .select('*')
      .order('order_index', { ascending: true });

    if (error) {
      console.error("Erreur Supabase :", error);
    } else {
      setSlides(data);
    }
  };

  fetchSlides();
}, []);
const getImageUrl = (path) =>
  `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${path}`;

  return (
<section className="slider-area" style={{ overflowX: 'hidden', width: '100%', position: 'relative' }}>
  <div className="text-center d-md-none mt-2">
    {/* <small className="text-muted">Swipe ⟷</small> */}
  </div>
  <MySlider slides={slides} settings={settings} />
{/* <Slider className="slider-active" {...settings}>
  {slides.map((slide, index) => (
    <div key={slide.id}>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: "url('img/slider/sliiider.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "729px",
          padding: "30px 15px",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="slider-content text-center text-md-start">
                <h2 className="desc" style={{ color: "darkgray", fontFamily: "cursive", fontSize: "1.5rem" }}>
                  PROMOTION
                </h2>
                <p className="title" style={{ color: "gray", fontSize: "2rem", fontWeight: "bold", fontFamily: "cursive" }}>
                  {slide.title}
                </p>
                <Link to="/shop" className="btn mt-2 d-inline-flex align-items-center" style={{ backgroundColor: "#ff41b4", color: "#fff", padding: "8px 16px", borderRadius: "20px" }}>
                  Shop
                  <img src="/img/icon/w_pawprint.png" alt="" className="ms-2" style={{ width: "20px" }} />
                </Link>
              </div>
            </div>
            <div className="col-md-6 text-center">
              <img
                src={getImageUrl(slide.image)}
                alt={slide.title}
                className="img-fluid"
                style={{ maxHeight: "240px", objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ))}
</Slider> */}

  {/* <Slider className="slider-active" {...settings}>
    {[
      {
        title: "Litiére Lindo Cat",
        image: "img/slider/lindo-cat-1-scaled.png"
      },
      {
        title: "Brit Care",
        image: "img/slider/brit-care-scaled.png"
      },
      {
        title: "Brit Premium",
        image: "img/slider/brit-premium-scaled.png"
      }
    ].map((slide, index) => (
      <div key={index}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: "url('img/slider/sl.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "400px",
            padding: "30px 15px",
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mb-4 mb-md-0">
                <div className="slider-content text-center text-md-start">
                  <h2
                    className="desc"
                    style={{
                      color: "darkgray",
                      fontFamily: "cursive",
                      fontSize: "1.5rem"
                    }}
                  >
                    PROMOTION
                  </h2>
                  <p
                    className="title"
                    style={{
                      color: "gray",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      fontFamily: "cursive"
                    }}
                  >
                    {slide.title}
                  </p>
                  <Link
                    to="/shop"
                    className="btn mt-2 d-inline-flex align-items-center"
                    style={{
                      backgroundColor: "#ff41b4",
                      color: "#fff",
                      padding: "8px 16px",
                      borderRadius: "20px"
                    }}
                  >
                    Shop <img src="img/icon/w_pawprint.png" alt="" className="ms-2" style={{ width: "20px" }} />
                  </Link>
                </div>
              </div>

              <div className="col-md-6 text-center">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="img-fluid"
                  style={{
                    maxHeight: "240px",
                    objectFit: "contain"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </Slider> */}

  {/* Decorative Shapes */}
  {/* <div className="slider-shape d-none d-md-block">
    <img src="img/slider/slider_shape01.png" alt="" />
  </div>
  <div className="slider-shape shape-two d-none d-md-block">
    <img src="img/slider/slider_shape02.png" alt="" />
  </div> */}
</section>

  );
}

export default MainSlider;
